export default function validationGenerationTfs(e, messages) {
  e.response.data.error.validationErrors.forEach((item) => {
    if (item.message.indexOf('GENERATION_TFS_ALREADY_IN_PROGRESS') === 0) {
      messages.push({
        message: 'listeDemande.validationDemande.demadeAlreadyInGeneration',
      });
    }
  });
}
